import React from 'react';
import Typography from '@mui/material/Typography';

const PayGatewayInfo = () => {
	return (
		<>
			<Typography
				variant="h6"
				display="block"
				color="inherit"
				gutterBottom>
				We don’t collect debit or credit card information
			</Typography>
			<Typography
				variant="body1"
				display="block"
				color="inherit"
				gutterBottom>
				We don’t collect credit card information on our website –
				purchasers using our website are using an embedded secure (
				<a
					href="https://stripe.com/"
					target="_blank"
					rel="noreferrer"
					css={{ color: 'orange' }}>
					Stripe.com
				</a>
				) payment system before they are asked for their payment
				details.
			</Typography>
			<Typography variant="body1" display="block" color="inherit">
				Stripe is an American financial services and software as a
				service (SaaS) company headquartered in San Francisco,
				California, United States. The company primarily offers payment
				processing software and application programming interfaces
				(APIs) for e-commerce websites and mobile applications
			</Typography>
		</>
	);
};

export default PayGatewayInfo;
